import { render, staticRenderFns } from "./InventoryStatus.vue?vue&type=template&id=36b0cd01&scoped=true"
import script from "./InventoryStatus.vue?vue&type=script&lang=js"
export * from "./InventoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0cd01",
  null
  
)

export default component.exports